/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import Markdown from 'bundles/ent-website/contentful/core/Markdown';
import type { BlockLevelModule } from 'bundles/ent-website/contentful/core/Module';

type Props = {
  description?: string | null;
  visible?: boolean;
  module: BlockLevelModule;
};
const styles: Record<string, Interpolation<Theme>> = {
  description: (theme) => css`
    p {
      font-size: 1.5rem !important;
      letter-spacing: -0.03em;
      ${theme.breakpoints.down('xs')} {
        font-size: 18px !important;
      }
    }
  `,
};

function Description({ description, visible, module }: Props) {
  if (!visible) {
    return null;
  }
  return (
    <Typography2 variant="bodyPrimary" component="div" color="inherit" css={styles.description}>
      <Markdown source={description} module={module} />
    </Typography2>
  );
}

export default Description;
